import React from 'react';
interface AdvertorialSectionProps {
  headline: string;
  content: string[];
  image: string;
  reverse?: boolean;
}
export const AdvertorialSection: React.FC<AdvertorialSectionProps> = ({
  headline,
  content,
  image,
  reverse = false
}) => {
  return <section className="w-full py-8 md:py-16 bg-white" data-id="element-198">
      <div className="container mx-auto px-4" data-id="element-199">
        {headline && <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-6 text-center" data-id="element-200">
            {headline}
          </h2>}
        <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center`} data-id="element-201">
          <div className="w-full md:w-1/2" data-id="element-202">
            <img src={image} alt={headline} className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg" data-id="element-203" />
          </div>
          <div className="w-full md:w-1/2" data-id="element-204">
            {content.map((paragraph, index) => <p key={index} className={`text-lg md:text-xl text-gray-700 ${paragraph ? 'mb-4' : 'mb-6'}`} data-id="element-205">
                {paragraph}
              </p>)}
          </div>
        </div>
      </div>
    </section>;
};